export const findStoreFromUserContext = (userContextObj) => {
  if (!userContextObj?.stores) return null;

  const localStoreName = localStorage.getItem("store");
  return userContextObj.stores.find((storeObj) =>
    localStoreName?.includes(storeObj.name)
  );
};

export const formatPhoneNumber = (rawPhone) => {
  if (/^\d{10}$/.test(rawPhone)) {
    return `(${rawPhone.slice(0, 3)}) ${rawPhone.slice(3, 6)}-${rawPhone.slice(6)}`;
  }
  return rawPhone || "";
};

export const getFormattedStoreTel = (userContextObj) => {
  const store = findStoreFromUserContext(userContextObj);
  const rawStoreTel = store && store.id ? (store.tel1 || store.tel2) : "";
  return formatPhoneNumber(rawStoreTel);
};